module.exports = __webpack_public_path__ + "img/1597011047.7947b07b.jpg";